export const TOURNAMENT_TYPE = ['tournament'];
export const WORLD_CUP_TYPE = ['world-cup'];

export const DESCRIPTION_MATCH_SELECT_OPTIONS = [
  {
    label: 'Sélectionner',
    value: 0
  },
  {
    label: 'Coupes du monde',
    value: WORLD_CUP_DESCRIPTIONS
  },
  {
    label: 'Tournois',
    value: TOURNAMENT_DESCRIPTION
  }
];

export const PHASE_DE_POULE_VALUE = 90;
export const MATCH_CLASSEMENT_VALUE = 35;
export const QUARTS_FINALE_VALUE = 40;
export const DEMI_FINALES_VALUE = 30;
export const FINALE_BRONZE_VALUE = 20;
export const FINALE_VALUE = 10;

export const WORLD_CUP_DESCRIPTIONS = [
  {
    label: 'Phase de poule',
    value: PHASE_DE_POULE_VALUE
  },
  {
    label: 'Quarts de finale',
    value: QUARTS_FINALE_VALUE
  },
  {
    label: 'Match de classement',
    value: MATCH_CLASSEMENT_VALUE
  },
  {
    label: 'Demi-finales',
    value: DEMI_FINALES_VALUE
  },
  {
    label: 'Finale de bronze',
    value: FINALE_BRONZE_VALUE
  },
  {
    label: 'Finale',
    value: FINALE_VALUE
  }
];

export const TOURNAMENT_DESCRIPTION = [
  {
    label: 'Journée 1',
    value: 1
  },
  {
    label: 'Journée 2',
    value: 2
  },
  {
    label: 'Journée 3',
    value: 3
  },
  {
    label: 'Journée 4',
    value: 4
  },
  {
    label: 'Journée 5',
    value: 5
  },
  {
    label: 'Journée 6',
    value: 6
  }
];
